import { Drawer } from "@mui/material";
import { useSelector } from "react-redux";
import { useLayout } from "../../contexts/LayoutContext";
import RemindersPanel from "../../pages/addressbook/panels/RemindersPanel";

/* Reminder inbox: a global overlay drawer summoned from the AppBar on any
   page, layered over the workspace without touching the exclusive panel
   group. Inside is the same RemindersPanel, in its fired-only inbox
   configuration — one implementation, two contexts. */

export default function ReminderInboxDrawer() {
  const { reminderInboxOpen, closeReminderInbox } = useLayout();
  const authorId = useSelector((state) => state.auth.userId);

  return (
    <Drawer
      anchor="right"
      open={reminderInboxOpen}
      onClose={closeReminderInbox}
      PaperProps={{ sx: { width: { xs: "100%", sm: 400 }, maxWidth: "100%" } }}
    >
      <RemindersPanel
        authorId={authorId}
        inboxMode
        onClose={closeReminderInbox}
      />
    </Drawer>
  );
}
